import { getPokemonSetIconUrl } from "utils/presentation";

export interface PreviewSetIconRenderProps {
  keyruneCode: string;
  setCode: string;
}

export type PreviewSetIconRenderer = (
  props: PreviewSetIconRenderProps
) => string;

function escapeHtml(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

export const renderKeyrunePreviewSetIcon: PreviewSetIconRenderer = ({
  keyruneCode,
  setCode,
}) => {
  const code =
    keyruneCode && keyruneCode !== "DEFAULT"
      ? keyruneCode.toLowerCase()
      : setCode.toLowerCase();
  return `<i class="ss ss-${escapeHtml(code)} set-icon"></i>`;
};

export const renderPokemonPreviewSetIcon: PreviewSetIconRenderer = ({
  setCode,
}) => {
  const iconUrl = getPokemonSetIconUrl(setCode);
  const escapedCode = escapeHtml(setCode.toUpperCase());
  if (!iconUrl) return `<span class="set-icon-text">${escapedCode}</span>`;
  return `<img
    src="${escapeHtml(iconUrl)}"
    class="set-icon-img"
    alt=""
    onerror="this.style.display='none';this.nextElementSibling.style.display='inline'"
  /><span class="set-icon-text" style="display:none">${escapedCode}</span>`;
};

export const renderCodePreviewSetIcon: PreviewSetIconRenderer = ({ setCode }) =>
  `<span class="set-icon-text">${escapeHtml(setCode.toUpperCase())}</span>`;
